import { Component, ElementRef, Input, HostBinding, ViewContainerRef, ComponentFactoryResolver } from '@angular/core';

@Component({
  selector: '[wl-busy-overlay]',
  templateUrl: 'busy-overlay.component.html',
  styleUrls: ['busy-overlay.component.css'],
  standalone: false
})
export class WlBusyOverlayComponent {
  /**
   * busy. bound to the name of the directive
   */
  @Input('wl-busy-overlay') public get busy(): boolean {
    return this._busy;
  }
  public set busy(value: boolean) {
    if (this._busy != value) {
      this._busy = value;
      this.handleBusyChange();
    }
  }

  /**
   * message to show next to busy animation
   */
  @Input() public busyMessage: string = '';

  /**
   * message to show next to busy animation
   */
  @Input() public busyCenter: boolean = false;

  /**
   * must be able to change the position attribute of the host element
   */
  @HostBinding('style.position') public _hostPosition: string;

  public _busy: boolean = false;

  /**
   * injection
   */
  constructor(public _viewContainerRef: ViewContainerRef, public _componentFactoryResolver: ComponentFactoryResolver) {}

  /**
   * show busy overlay
   */
  public showBusy(): void {
    this._hostPosition = 'relative';
  }

  /**
   * hide busy overlay
   */
  public hideBusy(): void {
    this._hostPosition = '';
  }

  /**
   * triggered when busy changes
   */
  public handleBusyChange(): void {
    if (this._busy) this.showBusy();
    else this.hideBusy();
  }
}
